<template>
  <div class="personnel">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <el-row :gutter="24">
      <el-col :span="5" class="leftCascader">
        <el-tree :data="pCodeListL"
                 ref="agentCascader"
                 node-key="code"
                 show-checkbox
                 default-expand-all
                 highlight-current
                 check-on-click-node
                 :expand-on-click-node="false"
                 @check="changeAgent"
        ></el-tree>
      </el-col>
      <el-col :span="19">
        <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
      </el-col>
    </el-row>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import FORM from '@/components/page/form.vue'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/analyse/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import Qs from 'qs'

let statusArr = { 1: '启用', 2: '禁用', 0: '待審批' }
let platformArr = { 'GTS2': 'GTS2', 'MT5': 'MT5' }
let settingIdArr = {}
let pCodeList = [], pCodeArr = {}
export default {
  name: 'personnel',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '代理名称', field: 'agentName' },
          { title: '關聯賬號', field: 'customerNumber' },
          { title: '手機號', field: 'phone' },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') },
          { click: window.$t('common.add'), auth: 'analyse:personnel:add' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.personnelList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '代理编码', field: 'code' },
          { title: '代理名称', field: 'agentName' },
          { title: '代理关联账号', field: 'customerNumber' },
          { title: '代理关联手机号', field: 'phone' },
          { title: '代理关联邮箱', field: 'email' },
          { title: '代理关联姓名', field: 'name' },
          { title: '支持平台', field: 'platform' },
          { title: '交易返佣方案', field: 'settingId' },
          { title: '代理級別', field: 'level' },
          { title: '上级代理', field: 'pCode' },
          { title: '创建人', field: 'cname' },
          {
            title: '创建时间', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '代理状态', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: '审批人', field: 'uname' },
          {
            title: '审批时间', field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '开户链接', field: 'agentAcUrl' },
          { title: '代理链接', field: 'agentInviteUrl' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'analyse:personnel:del'
              },
              {
                name: window.$t('common.edit'),
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'analyse:personnel:edit'
              },
              {
                name: window.$t('common.approve'),
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'analyse:personnel:approve', hidden: (data, full) => {
                  return full.status == 1
                }
              },
              {
                name: window.$t('common.reject'),
                click: 'reject',
                type: 'primary',
                icon: 'el-icon-reject',
                auth: 'analyse:personnel:reject', hidden: (data, full) => {
                  return full.status == 2
                }
              }
            ]
          }
        ]
      },
      /*新增或更新*/
      updateData: {
        cols: [
          { title: '代理编码', field: 'code', data: '', disabled: true, hidden: true },
          {
            title: '所属代理',
            field: 'pCode',
            type: 15,
            optionList: pCodeList,
            data: [],
            checkStrictly: true
          },
          { title: '代理名称', field: 'agentName', data: '', required: true },
          {
            title: '交易返佣方案',
            field: 'settingId',
            type: 2,
            optionList: {},
            required: true,
            isNumber: true
          },
          {
            title: '支持平台',
            field: 'platform',
            type: 4,
            optionList: platformArr,
            data: ['GTS2', 'MT5'],
            required: true,
            disabled: true
          },
          { title: '姓名', field: 'name', data: '', required: true },
          { title: '手机号', field: 'phone', data: '', required: true, isNumber: true, textType: 'number' },
          { title: '邮箱', field: 'email', data: '', required: true },
          { title: '代理关联账号', field: 'customerNumber', data: '', required: true, isNumber: true, textType: 'number' },
          { title: '备注', field: 'remark', data: '' }
        ]
      },
      pCodeListL: []
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    changeAgent(arr, checked) {
      if (checked) {
        this.$refs.agentCascader.setCheckedKeys([arr.code])
        let option = {
          code: arr.code
        }
        this.queryData = option
        this.$refs.childTable.defaultGetData(option)
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
        this.$refs.agentCascader.setCheckedNodes([])
      } else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.updateData.cols.find(function(e) {
          return e.field == 'pCode'
        }).disabled = false
        this.$refs.childUpdate.open()
      }
    },
    delNodes(nodes = []) {
      for (let item of nodes) {
        if (item.children.length <= 0) {
          delete item.children
        } else {
          this.delNodes(item.children)
        }
      }
      return nodes
    },
    addNodes(data) {
      for (let i in data) {
        pCodeArr[data[i].value] = data[i].label
        if (data[i].children && data[i].children.length > 0) {
          this.addNodes(data[i].children)
        }
      }
      return pCodeArr
    },
    personnelCascader() {
      this.$axios.get(Url.adAgent.personnelCascader).then(res => {
        if (res.code == 0) {
          if (res.result) {
            let data = JSON.parse(JSON.stringify(res.result))
            this.delNodes(data)
            pCodeList = data
            this.updateData.cols.find(function(e) {
              return e.field == 'pCode'
            }).optionList = data
            this.addNodes(data)
            this.pCodeListL = data
          }
        }
      })
    },
    rebateSetListAll() {
      this.$axios.get(Url.adAgent.rebateSetListAll).then(res => {
        if (res.code == 0) {
          let arr = {}
          if (res.result) {
            let data = res.result
            for (const i in data) {
              arr[data[i].id] = data[i].name
            }
          }
          settingIdArr = arr
          this.updateData.cols.find(function(e) {
            return e.field == 'settingId'
          }).optionList = arr
        }
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        this.updateData.cols.find(function(e) {
          return e.field == 'pCode'
        }).disabled = true
        row.pCode = row.cascadeCodes ? row.cascadeCodes.split('|') : ''
        row.platform = row.platform ? row.platform.toUpperCase().split(',') : ''
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'delete') {
        let option = {
          code: row.code
        }
        this.dataChange(Url.adAgent.personnelDel, option, res => {
          if (res.code == 0) {
            this.$message.success('suc')
            this.$refs.childTable.defaultGetData(this.queryData)
            this.personnelCascader()
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'reject' || clickName == 'approve') {
        let option = {
          code: row.code,
          status: clickName == 'approve' ? 1 : 2
        }
        this.dataChange(Url.adAgent.personnelStatus, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
            this.personnelCascader()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.platform = model.platform.join(',')
      if (model.pCode) model.pCode = model.pCode.join(',')
      this.dataChange(Url.adAgent.personnelEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  mounted() {
    this.personnelCascader()
    this.rebateSetListAll()
  }
}
</script>

<style>
.personnel .leftCascader {
  padding: 10px 0 0 20px !important;
}

.personnel .leftCascader .el-checkbox__inner {
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
}

.personnel .leftCascader .el-checkbox__input.is-checked .el-checkbox__inner,
.personnel .leftCascader .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #409eff;
  background: #409eff;
}

.personnel .leftCascader .el-checkbox__inner:after {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #fff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform .15s ease-in;
}

.personnel .leftCascader .el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: translate(-50%, -50%) scale(1);
}
</style>
